import React from 'react';
import { FormattedMessage } from 'react-intl';
import BreadcrumbContainer from 'components/breadcrumb_container';
import IndexContainer from 'components/inspection_subject/index_container';
import { BreadCrumbTypography } from 'components/styles_components/typography';
import { PaginateProvider } from 'contexts/paginate';
import Container from 'components/layout/container';

const InspectionSubjects = () => {
  return (
    <PaginateProvider>
      <Container>
        <BreadcrumbContainer>
          <BreadCrumbTypography>
            <FormattedMessage id="breadcrumb.inspection_subjects.index" />
          </BreadCrumbTypography>
        </BreadcrumbContainer>
        <IndexContainer />
      </Container>
    </PaginateProvider>
  );
};

export default InspectionSubjects;
